export enum IconOrientation {
    Raise = "Raise",
    Flatten = "Flatten"
}